import { render, staticRenderFns } from "./MenteeView.vue?vue&type=template&id=2a75cbcd&"
import script from "./MenteeView.vue?vue&type=script&lang=js&"
export * from "./MenteeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports